// DynamicField.js
import { useRef, useState } from '@wordpress/element';
import { __ } from '@wordpress/i18n';

const DynamicField = ({ field, area, onEdit, onDelete, onMoveUp, onMoveDown, canMoveUp, canMoveDown, isMoving }) => {
  const [isHovered, setIsHovered] = useState(false);
  const isProcessingRef = useRef(false);
  
  const renderFieldContent = () => {
    switch (field.type) {
      case 'carousel':
        return (
          <div className="hvnly--builder---api_property__singleProperty__builder__gallery_content">
            <div className="hvnly--builder---api_property__singleProperty__builder__gallery_carousel">
              <i className="fas fa-images"></i>
              <span>{__('Property Image Carousel', 'havenlytics')}</span>
            </div>
          </div>
        );
      case 'map':
        return (
          <div className="hvnly--builder---api_property__singleProperty__builder__gallery_content">
            <div className="hvnly--builder---api_property__singleProperty__builder__gallery_map">
              <i className="fas fa-map"></i>
              <span>{__('Property Location Map', 'havenlytics')}</span>
            </div>
          </div>
        );

      case 'title':
        return <h1>{__('Modern Luxury Villa', 'havenlytics')}</h1>;
      case 'location':
        return (
          <div className="hvnly--builder---api_property__singleProperty__builder__location">
            <i className="fas fa-map-marker-alt"></i>
            <span>{field.label}{__('123 Sunshine Boulevard, Miami, FL', 'havenlytics')}
</span>
          </div>
        );
      case 'price':
        return (
          <div className="hvnly--builder---api_property__singleProperty__builder__price_area">
            <div className="hvnly--builder---api_property__singleProperty__builder__price">$1,250,000</div>
          
          </div>
        );
      case 'rating':
        return (
                   
        <div className="hvnly--builder---api_property__singleProperty__builder__rating">
          <div className="hvnly--builder---api_property__singleProperty__builder__stars_container">
            {[1, 2, 3, 4, 5].map((star) => (
              <i key={star} className="fas fa-star"></i>
            ))}
          </div>
          <span className="hvnly--builder---api_property__singleProperty__builder__rating_text">{__('5.0 (24 reviews)', 'havenlytics')}</span>
        </div>
        );
      case 'share':
        return (
          <div className="hvnly--builder---api_property__singleProperty__builder__tags hvnly--builder---api_property__singleProperty__builder__share">{field.label}</div>
          
        );
      case 'departments':
        return (
          <div className="hvnly--builder---api_property__singleProperty__builder__tags featured">{field.label}</div>
          
        );
      case 'labels':
        return (
          <div className="hvnly--builder---api_property__singleProperty__builder__tags featured">{field.label}</div>
          
        );
      case 'tags':
        return (
          <div className="hvnly--builder---api_property__singleProperty__builder__tags featured">{field.label}</div>
          
        );
      case 'featured':
        return (
          <div className="hvnly--builder---api_property__singleProperty__builder__tags featured">{field.label}</div>
          
        );
      case 'popular':
        return (
          <div className="hvnly--builder---api_property__singleProperty__builder__tags featured">{field.label}</div>
          
        );
      case 'overview':
        return (
            <div className="hvnly--builder---api_property__singleProperty__builder__details">
              {/* Default Static Detail Items */}
              <div className="hvnly--builder---api_property__singleProperty__builder__detail_item">
                <i className="fas fa-bed"></i>
                <div className="value">4</div>
                <div className="label">{__('Bedrooms', 'havenlytics')}</div>
              </div>
              <div className="hvnly--builder---api_property__singleProperty__builder__detail_item">
                <i className="fas fa-bath"></i>
                <div className="value">3</div>
                <div className="label">{__('Bathrooms', 'havenlytics')}</div>
              </div>
              <div className="hvnly--builder---api_property__singleProperty__builder__detail_item">
                <i className="fas fa-ruler-combined"></i>
                <div className="value">3,200</div>
                <div className="label">{__('Sq Ft', 'havenlytics')}</div>
              </div>
              <div className="hvnly--builder---api_property__singleProperty__builder__detail_item">
                <i className="fas fa-calendar-alt"></i>
                <div className="value">2020</div>
                <div className="label">{__('Year Built', 'havenlytics')}</div>
              </div>
              <div className="hvnly--builder---api_property__singleProperty__builder__detail_item">
                <i className="fas fa-car"></i>
                <div className="value">2</div>
                <div className="label">{__('Garage', 'havenlytics')}</div>
              </div>
              <div className="hvnly--builder---api_property__singleProperty__builder__detail_item">
                <i className="fas fa-layer-group"></i>
                <div className="value">2</div>
                <div className="label">{__('Stories', 'havenlytics')}</div>
              </div>
              <div className="hvnly--builder---api_property__singleProperty__builder__detail_item">
                <i className="fas fa-vector-square"></i>
                <div className="value">0.5</div>
                <div className="label">{__('Lot Size', 'havenlytics')}</div>
              </div>
              <div className="hvnly--builder---api_property__singleProperty__builder__detail_item">
                <i className="fas fa-tree"></i>
                <div className="value">{__('Yes', 'havenlytics')}</div>
                <div className="label">{__('Garden', 'havenlytics')}</div>
              </div>
              
            </div>
        );
      case 'features':
        return (

            <div className="hvnly--builder---api_property__singleProperty__builder__features_list">
              <div className="hvnly--builder---api_property__singleProperty__builder__feature_item">
                <i className="fas fa-swimming-pool"></i>
                <span>{__('Swimming Pool', 'havenlytics')}</span>
              </div>
              <div className="hvnly--builder---api_property__singleProperty__builder__feature_item">
                <i className="fas fa-car"></i>
                <span>{__('2-Car Garage', 'havenlytics')}</span>
              </div>
              <div className="hvnly--builder---api_property__singleProperty__builder__feature_item">
                <i className="fas fa-snowflake"></i>
                <span>{__('Air Conditioning', 'havenlytics')}</span>
              </div>
              <div className="hvnly--builder---api_property__singleProperty__builder__feature_item">
                <i className="fas fa-shield-alt"></i>
                <span>{__('Security System', 'havenlytics')}</span>
              </div>
              <div className="hvnly--builder---api_property__singleProperty__builder__feature_item">
                <i className="fas fa-dumbbell"></i>
                <span>{__('Home Gym', 'havenlytics')}</span>
              </div>
              <div className="hvnly--builder---api_property__singleProperty__builder__feature_item">
                <i className="fas fa-fire"></i>
                <span>{__('Fireplace', 'havenlytics')}</span>
              </div>
              <div className="hvnly--builder---api_property__singleProperty__builder__feature_item">
                <i className="fas fa-wifi"></i>
                <span>{__('Smart Home', 'havenlytics')}</span>
              </div>
              <div className="hvnly--builder---api_property__singleProperty__builder__feature_item">
                <i className="fas fa-hot-tub"></i>
                <span>{__('Jacuzzi', 'havenlytics')}</span>
              </div>
              <div className="hvnly--builder---api_property__singleProperty__builder__feature_item">
                <i className="fas fa-utensils"></i>
                <span>{__('Modern Kitchen', 'havenlytics')}</span>
              </div>
              <div className="hvnly--builder---api_property__singleProperty__builder__feature_item">
                <i className="fas fa-wine-glass-alt"></i>
                <span>{__('Wine Cellar', 'havenlytics')}</span>
              </div>
              <div className="hvnly--builder---api_property__singleProperty__builder__feature_item">
                <i className="fas fa-gamepad"></i>
                <span>{__('Game Room', 'havenlytics')}</span>
              </div>
              <div className="hvnly--builder---api_property__singleProperty__builder__feature_item">
                <i className="fas fa-theater-masks"></i>
                <span>{__('Home Theater', 'havenlytics')}</span>
              </div>
            </div>
             
        );

        case 'book property':
          return (
            <div className="hvnly--builder---api_property__singleProperty__builder__amenities_item">
              <i className="fas fa-calendar-check"></i>
              <div className="label">{field.label}</div>
            </div>
          );
        case 'mortgage calculator':
          return (
            <div className="hvnly--builder---api_property__singleProperty__builder__amenities_item">
              <i className="fas fa-calculator"></i>
              <div className="label">{field.label}</div>
            </div>
          );
        case 'virtual tour':
          return (
            <div className="hvnly--builder---api_property__singleProperty__builder__amenities_item">
              <i className="fas fa-vr-cardboard"></i>
              <div className="label">{field.label}</div>
            </div>
          );
        case 'floorplan':
          return (
            <div className="hvnly--builder---api_property__singleProperty__builder__amenities_item">
              <i className="fas fa-project-diagram"></i>
              <div className="label">{field.label}</div>
            </div>
          );
        case 'view brochure':
          return (
            <div className="hvnly--builder---api_property__singleProperty__builder__amenities_item">
              <i className="fas fa-file-pdf"></i>
              <div className="label">{field.label}</div>
            </div>
          );
        case 'view epc':
          return (
            <div className="hvnly--builder---api_property__singleProperty__builder__amenities_item">
              <i className="fas fa-chart-line"></i>
              <div className="label">{field.label}</div>
            </div>
          );
        case 'property map':
          return (
            <div className="hvnly--builder---api_property__singleProperty__builder__amenities_item">
              <i className="fas fa-map-marked-alt"></i>
              <div className="label">{field.label}</div>
            </div>
          );
        case 'request callback':
          return (
            <div className="hvnly--builder---api_property__singleProperty__builder__amenities_item">
              <i className="fas fa-phone-alt"></i>
              <div className="label">{field.label}</div>
            </div>
          );
        case 'arrange viewing':
          return (
            <div className="hvnly--builder---api_property__singleProperty__builder__amenities_item">
              <i className="fas fa-eye"></i>
              <div className="label">{field.label}</div>
            </div>
          );


      case 'featured carousel':
        return (
          <div className="hvnly--builder---api_property__singleProperty__builder__sidebar_card_content">
            <p>{__('This property is featured in our luxury collection and has been viewed by over 1,250 potential buyers in the last month.', 'havenlytics')}</p>
            <div className="hvnly--builder---api_property__singleProperty__builder__sidebar_card_stats">
              <div className="hvnly--builder---api_property__singleProperty__builder__sidebar_card_stat">
                <div className="hvnly--builder---api_property__singleProperty__builder__sidebar_card_stat_value">1,250</div>
                <div className="hvnly--builder---api_property__singleProperty__builder__sidebar_card_stat_label">{__('Views', 'havenlytics')}</div>
              </div>
              <div className="hvnly--builder---api_property__singleProperty__builder__sidebar_card_stat">
                <div className="hvnly--builder---api_property__singleProperty__builder__sidebar_card_stat_value">85</div>
                <div className="hvnly--builder---api_property__singleProperty__builder__sidebar_card_stat_label">{__('Inquiries', 'havenlytics')}</div>
              </div>
              <div className="hvnly--builder---api_property__singleProperty__builder__sidebar_card_stat">
                <div className="hvnly--builder---api_property__singleProperty__builder__sidebar_card_stat_value">12</div>
                <div className="hvnly--builder---api_property__singleProperty__builder__sidebar_card_stat_label">{__('Tours', 'havenlytics')}</div>
              </div>
            </div>
          </div>
        );


      case 'square feet':
        return (
          <div className="hvnly--builder---api_property__singleProperty__builder__detail_item">
            <i className="fas fa-ruler-combined"></i>
            <div className="value">3,200</div>
            <div className="label">{__('Sq Ft', 'havenlytics')}</div>
          </div>
        );
      case 'year built':
        return (
          <div className="hvnly--builder---api_property__singleProperty__builder__detail_item">
            <i className="fas fa-calendar-alt"></i>
            <div className="value">2020</div>
            <div className="label">{__('Year Built', 'havenlytics')}</div>
          </div>
        );
      case 'garage':
        return (
          <div className="hvnly--builder---api_property__singleProperty__builder__detail_item">
            <i className="fas fa-car"></i>
            <div className="value">2</div>
            <div className="label">{__('Garage', 'havenlytics')}</div>
          </div>
        );
      case 'property type':
        return (
          <div className="hvnly--builder---api_property__singleProperty__builder__detail_item">
            <i className="fas fa-home"></i>
            <div className="value">{__('Villa', 'havenlytics')}</div>
            <div className="label">{__('Type', 'havenlytics')}</div>
          </div>
        );

      case 'chart':
        return (
          <div className="hvnly--builder---api_property__singleProperty__builder__sidebar_card_content">
            <div className="hvnly--builder---api_property__singleProperty__builder__sidebar_card_stats">
              <div className="hvnly--builder---api_property__singleProperty__builder__sidebar_card_stat">
                <div className="hvnly--builder---api_property__singleProperty__builder__sidebar_card_stat_value">312</div>
                <div className="hvnly--builder---api_property__singleProperty__builder__sidebar_card_stat_label">{__('Mon', 'havenlytics')}</div>
              </div>
              <div className="hvnly--builder---api_property__singleProperty__builder__sidebar_card_stat">
                <div className="hvnly--builder---api_property__singleProperty__builder__sidebar_card_stat_value">285</div>
                <div className="hvnly--builder---api_property__singleProperty__builder__sidebar_card_stat_label">{__('Tue', 'havenlytics')}</div>
              </div>
              <div className="hvnly--builder---api_property__singleProperty__builder__sidebar_card_stat">
                <div className="hvnly--builder---api_property__singleProperty__builder__sidebar_card_stat_value">342</div>
                <div className="hvnly--builder---api_property__singleProperty__builder__sidebar_card_stat_label">{__('Wed', 'havenlytics')}</div>
              </div>
              <div className="hvnly--builder---api_property__singleProperty__builder__sidebar_card_stat">
                <div className="hvnly--builder---api_property__singleProperty__builder__sidebar_card_stat_value">298</div>
                <div className="hvnly--builder---api_property__singleProperty__builder__sidebar_card_stat_label">{__('Thu', 'havenlytics')}</div>
              </div>
              <div className="hvnly--builder---api_property__singleProperty__builder__sidebar_card_stat">
                <div className="hvnly--builder---api_property__singleProperty__builder__sidebar_card_stat_value">365</div>
                <div className="hvnly--builder---api_property__singleProperty__builder__sidebar_card_stat_label">{__('Fri', 'havenlytics')}</div>
              </div>
              <div className="hvnly--builder---api_property__singleProperty__builder__sidebar_card_stat">
                <div className="hvnly--builder---api_property__singleProperty__builder__sidebar_card_stat_value">276</div>
                <div className="hvnly--builder---api_property__singleProperty__builder__sidebar_card_stat_label">{__('Sat', 'havenlytics')}</div>
              </div>
              <div className="hvnly--builder---api_property__singleProperty__builder__sidebar_card_stat">
                <div className="hvnly--builder---api_property__singleProperty__builder__sidebar_card_stat_value">198</div>
                <div className="hvnly--builder---api_property__singleProperty__builder__sidebar_card_stat_label">{__('Sun', 'havenlytics')}</div>
              </div>
            </div>
          </div>
        );
      
      case 'agentinfo':
        return (
          <div className="hvnly--builder---api_property__singleProperty__builder__agent_info">
            {/* Agent Profile */}
            <div className="hvnly--builder---api_property__singleProperty__builder__agent_profile">
              <div className="hvnly--builder---api_property__singleProperty__builder__agent_avatar">
                <div className="hvnly--builder---api_property__singleProperty__builder__agent_icon">
                  <i className="fas fa-user-tie"></i>
                </div>
                <div className="hvnly--builder---api_property__singleProperty__builder__agent_verified">
                  <i className="fas fa-check-circle"></i>
                </div>
              </div>
              <div className="hvnly--builder---api_property__singleProperty__builder__agent_details">
                <h4 className="hvnly--builder---api_property__singleProperty__builder__agent_name">{__('Sarah Johnson', 'havenlytics')}</h4>
                <p className="hvnly--builder---api_property__singleProperty__builder__agent_title">{__('Senior Real Estate Agent', 'havenlytics')}</p>
                <div className="hvnly--builder---api_property__singleProperty__builder__agent_rating">
                  <div className="hvnly--builder---api_property__singleProperty__builder__stars">
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star-half-alt"></i>
                  </div>
                  <span className="hvnly--builder---api_property__singleProperty__builder__rating_text">{__('4.8 (127 reviews)', 'havenlytics')}</span>
                </div>
              </div>
            </div>
            
            {/* Agent Contact Info */}
            <div className="hvnly--builder---api_property__singleProperty__builder__agent_contact">
              <div className="hvnly--builder---api_property__singleProperty__builder__contact_item">
                <div className="hvnly--builder---api_property__singleProperty__builder__contact_icon">
                  <i className="fas fa-phone"></i>
                </div>
                <div className="hvnly--builder---api_property__singleProperty__builder__contact_info">
                  <span className="hvnly--builder---api_property__singleProperty__builder__contact_label">{__('Phone', 'havenlytics')}</span>
                  <span className="hvnly--builder---api_property__singleProperty__builder__contact_value">+1 (555) 123-4567</span>
                </div>
              </div>
              
              <div className="hvnly--builder---api_property__singleProperty__builder__contact_item">
                <div className="hvnly--builder---api_property__singleProperty__builder__contact_icon">
                  <i className="fas fa-envelope"></i>
                </div>
                <div className="hvnly--builder---api_property__singleProperty__builder__contact_info">
                  <span className="hvnly--builder---api_property__singleProperty__builder__contact_label">{__('Email', 'havenlytics')}</span>
                  <span className="hvnly--builder---api_property__singleProperty__builder__contact_value">sarah@luxuryhomes.com</span>
                </div>
              </div>
              
              <div className="hvnly--builder---api_property__singleProperty__builder__contact_item">
                <div className="hvnly--builder---api_property__singleProperty__builder__contact_icon">
                  <i className="fas fa-briefcase"></i>
                </div>
                <div className="hvnly--builder---api_property__singleProperty__builder__contact_info">
                  <span className="hvnly--builder---api_property__singleProperty__builder__contact_label">{__('Experience', 'havenlytics')}</span>
                  <span className="hvnly--builder---api_property__singleProperty__builder__contact_value">{__('8+ years', 'havenlytics')}</span>
                </div>
              </div>
            </div>
            
            {/* Agent Action Buttons */}
            <div className="hvnly--builder---api_property__singleProperty__builder__agent_actions">
              <button className="hvnly--builder---api_property__singleProperty__builder__agent_btn hvnly--builder---api_property__singleProperty__builder__agent_btn_primary">
                <i className="fas fa-phone"></i>
                {__('Call Now', 'havenlytics')}
              </button>
              <button className="hvnly--builder---api_property__singleProperty__builder__agent_btn hvnly--builder---api_property__singleProperty__builder__agent_btn_secondary">
                <i className="fas fa-envelope"></i>
                {__('Send Email', 'havenlytics')}
              </button>
            </div>
            
            {/* Agent Stats */}
            <div className="hvnly--builder---api_property__singleProperty__builder__agent_stats">
              <div className="hvnly--builder---api_property__singleProperty__builder__agent_stat">
                <div className="hvnly--builder---api_property__singleProperty__builder__stat_value">42</div>
                <div className="hvnly--builder---api_property__singleProperty__builder__stat_label">{__('Properties Sold', 'havenlytics')}</div>
              </div>
              <div className="hvnly--builder---api_property__singleProperty__builder__agent_stat">
                <div className="hvnly--builder---api_property__singleProperty__builder__stat_value">$98M</div>
                <div className="hvnly--builder---api_property__singleProperty__builder__stat_label">{__('Total Sales', 'havenlytics')}</div>
              </div>
              <div className="hvnly--builder---api_property__singleProperty__builder__agent_stat">
                <div className="hvnly--builder---api_property__singleProperty__builder__stat_value">24h</div>
                <div className="hvnly--builder---api_property__singleProperty__builder__stat_label">{__('Avg Response', 'havenlytics')}</div>
              </div>
            </div>
          </div>
        );

        case 'agentform':
          return (
            <div className="hvnly--builder---api_property__singleProperty__builder__agent_form_modern">
              <div className="hvnly--builder---api_property__singleProperty__builder__agent_form_card">
                {/* Agent Header */}
                <div className="hvnly--builder---api_property__singleProperty__builder__agent_form_header">
                  <div className="hvnly--builder---api_property__singleProperty__builder__agent_avatar_large">
                    <div className="hvnly--builder---api_property__singleProperty__builder__agent_avatar_icon">
                      <i className="fas fa-user-tie"></i>
                    </div>
                    <div className="hvnly--builder---api_property__singleProperty__builder__agent_verified_badge">
                      <i className="fas fa-check"></i>
                    </div>
                  </div>
                  <div className="hvnly--builder---api_property__singleProperty__builder__agent_header_content">
                    <h3 className="hvnly--builder---api_property__singleProperty__builder__agent_form_name">
                      {__('Brittany Watkins', 'havenlytics')}
                    </h3>
                    <p className="hvnly--builder---api_property__singleProperty__builder__agent_form_title">
                      {__('Senior Real Estate Agent', 'havenlytics')}
                    </p>
                    <div className="hvnly--builder---api_property__singleProperty__builder__agent_rating">
                      <div className="hvnly--builder---api_property__singleProperty__builder__rating_stars">
                        <i className="fas fa-star"></i>
                        <i className="fas fa-star"></i>
                        <i className="fas fa-star"></i>
                        <i className="fas fa-star"></i>
                        <i className="fas fa-star-half-alt"></i>
                      </div>
                      <span className="hvnly--builder---api_property__singleProperty__builder__rating_text">{__('4.8 (127 reviews)', 'havenlytics')}</span>
                    </div>
                  </div>
                </div>

                {/* Quick Contact Buttons */}
                <div className="hvnly--builder---api_property__singleProperty__builder__quick_contact">
                  <a href="tel:3214569874" className="hvnly--builder---api_property__singleProperty__builder__quick_btn">
                    <i className="fas fa-phone"></i>
                    {__('Call Now', 'havenlytics')}
                  </a>
                  <a href="#" className="hvnly--builder---api_property__singleProperty__builder__quick_btn">
                    <i className="fab fa-whatsapp"></i>
                    {__('WhatsApp', 'havenlytics')}
                  </a>
                </div>

                {/* Form Section */}
                <div className="hvnly--builder---api_property__singleProperty__builder__form_section">
                  <h4 className="hvnly--builder---api_property__singleProperty__builder__form_section_title">
                    {__('Send a Message', 'havenlytics')}
                  </h4>
                  
                  <form className="hvnly--builder---api_property__singleProperty__builder__modern_form">
                    {/* Name & Phone Row */}
                    <div className="hvnly--builder---api_property__singleProperty__builder__form_row">
                      <div className="hvnly--builder---api_property__singleProperty__builder__form_field">
                        <div className="hvnly--builder---api_property__singleProperty__builder__input_container">
                          <i className="fas fa-user"></i>
                          <input 
                            type="text" 
                            className="hvnly--builder---api_property__singleProperty__builder__modern_input" 
                            placeholder={__('Your Name', 'havenlytics')}
                          />
                        </div>
                      </div>
                      
                      <div className="hvnly--builder---api_property__singleProperty__builder__form_field">
                        <div className="hvnly--builder---api_property__singleProperty__builder__input_container">
                          <i className="fas fa-phone"></i>
                          <input 
                            type="tel" 
                            className="hvnly--builder---api_property__singleProperty__builder__modern_input" 
                            placeholder={__('Phone Number', 'havenlytics')}
                          />
                        </div>
                      </div>
                    </div>

                    {/* Email Field */}
                    <div className="hvnly--builder---api_property__singleProperty__builder__form_field">
                      <div className="hvnly--builder---api_property__singleProperty__builder__input_container">
                        <i className="fas fa-envelope"></i>
                        <input 
                          type="email" 
                          className="hvnly--builder---api_property__singleProperty__builder__modern_input" 
                          placeholder={__('Email Address', 'havenlytics')}
                        />
                      </div>
                    </div>

                    {/* Message Field */}
                    <div className="hvnly--builder---api_property__singleProperty__builder__form_field">
                      <div className="hvnly--builder---api_property__singleProperty__builder__input_container hvnly--builder---api_property__singleProperty__builder__textarea_container">
                        <i className="fas fa-comment"></i>
                        <textarea 
                          className="hvnly--builder---api_property__singleProperty__builder__modern_textarea" 
                          placeholder={__('Hello, I\'m interested in this property. Please contact me with more details.', 'havenlytics')}
                          rows="4"
                        ></textarea>
                      </div>
                    </div>

                    {/* Dropdown Field */}
                    <div className="hvnly--builder---api_property__singleProperty__builder__form_field">
                      <div className="hvnly--builder---api_property__singleProperty__builder__input_container hvnly--builder---api_property__singleProperty__builder__modern_select_dropdown">
                        {/* <i className="fas fa-user-tag"></i> */}
                        <select className="hvnly--builder---api_property__singleProperty__builder__modern_select">
                          <option value="">{__('I am a...', 'havenlytics')}</option>
                          <option value="buyer">{__('Buyer', 'havenlytics')}</option>
                          <option value="tenant">{__('Tenant', 'havenlytics')}</option>
                          <option value="agent">{__('Agent', 'havenlytics')}</option>
                          <option value="other">{__('Other', 'havenlytics')}</option>
                        </select>
                        <i className="fas fa-chevron-down hvnly--builder---api_property__singleProperty__builder__select_chevron"></i>
                      </div>
                    </div>

                    {/* GDPR Checkbox */}
                    <div className="hvnly--builder---api_property__singleProperty__builder__checkbox_field">
                      <label className="hvnly--builder---api_property__singleProperty__builder__modern_checkbox">
                        <input type="checkbox" />
                        <span className="hvnly--builder---api_property__singleProperty__builder__checkmark"></span>
                        <span className="hvnly--builder---api_property__singleProperty__builder__checkbox_text">
                          {__('I agree to the', 'havenlytics')} <a href="#">{__('Terms of Use', 'havenlytics')}</a>
                        </span>
                      </label>
                    </div>

                    {/* Submit Button */}
                    <button type="submit" className="hvnly--builder---api_property__singleProperty__builder__submit_btn">
                      <i className="fas fa-paper-plane"></i>
                      {__('Send Message to Agent', 'havenlytics')}
                    </button>
                  </form>
                </div>

                {/* Agent Stats */}
                <div className="hvnly--builder---api_property__singleProperty__builder__agent_stats_modern">
                  <div className="hvnly--builder---api_property__singleProperty__builder__stat_item">
                    <div className="hvnly--builder---api_property__singleProperty__builder__stat_number">42</div>
                    <div className="hvnly--builder---api_property__singleProperty__builder__stat_label">{__('Properties Sold', 'havenlytics')}</div>
                  </div>
                  <div className="hvnly--builder---api_property__singleProperty__builder__stat_item">
                    <div className="hvnly--builder---api_property__singleProperty__builder__stat_number">$98M</div>
                    <div className="hvnly--builder---api_property__singleProperty__builder__stat_label">{__('Total Sales', 'havenlytics')}</div>
                  </div>
                  <div className="hvnly--builder---api_property__singleProperty__builder__stat_item">
                    <div className="hvnly--builder---api_property__singleProperty__builder__stat_number">24h</div>
                    <div className="hvnly--builder---api_property__singleProperty__builder__stat_label">{__('Avg Response', 'havenlytics')}</div>
                  </div>
                </div>
              </div>
            </div>
          );

      default:
        return null;
    }
  };

  const handleEdit = (e) => {
    e.stopPropagation();
    e.preventDefault();
    
    // Prevent multiple edits
    if (isProcessingRef.current) return;
    isProcessingRef.current = true;
    
    onEdit(field, area);
    
    // Reset the ref after a short delay
    setTimeout(() => {
      isProcessingRef.current = false;
    }, 300);
  };

  const handleDelete = (e) => {
    e.stopPropagation();
    e.preventDefault();
    
    // Prevent multiple deletes
    if (isProcessingRef.current) return;
    isProcessingRef.current = true;
    
    onDelete(area, field.id);
    
    // Reset the ref after a short delay
    setTimeout(() => {
      isProcessingRef.current = false;
    }, 300);
  };

  const handleMoveUp = (e) => {
    e.stopPropagation();
    e.preventDefault();
    
    // Prevent multiple moves
    if (isProcessingRef.current) return;
    isProcessingRef.current = true;
    
    onMoveUp(area, field.id);
    
    // Reset the ref after a short delay
    setTimeout(() => {
      isProcessingRef.current = false;
    }, 300);
  };

  const handleMoveDown = (e) => {
    e.stopPropagation();
    e.preventDefault();
    
    // Prevent multiple moves
    if (isProcessingRef.current) return;
    isProcessingRef.current = true;
    
    onMoveDown(area, field.id);
    
    // Reset the ref after a short delay
    setTimeout(() => {
      isProcessingRef.current = false;
    }, 300);
  };

  // For details area, we need special handling since fields are inside the grid
  if (area === 'details') {
    return (
      <div 
        className={` ${isMoving ? 'moving' : ''}`}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        style={{ position: 'relative' }}
      >
        {/* Action buttons - positioned above the field content */}
        <div className={`hvnly--builder---api_property__singleProperty__builder__field_actions ${isHovered ? 'show' : ''}`}>
          {canMoveUp && (
            <button
              type="button"
              className="hvnly_property_builder_field_action_btn move-up-btn"
              onClick={handleMoveUp}
              title={__("Move Up", "havenlytics")}
            >
              <i className="fas fa-arrow-up"></i>
            </button>
          )}
          
          {canMoveDown && (
            <button
              type="button"
              className="hvnly_property_builder_field_action_btn move-down-btn"
              onClick={handleMoveDown}
              title={__("Move Down", "havenlytics")}
            >
              <i className="fas fa-arrow-down"></i>
            </button>
          )}
          
          <button
            type="button"
            className="hvnly_property_builder_field_action_btn edit-btn"
            onClick={handleEdit}
            title={__("Edit", "havenlytics")}
          >
            <i className="fas fa-edit"></i>
          </button>
          
          <button
            type="button"
            className="hvnly_property_builder_field_action_btn delete-btn"
            onClick={handleDelete}
            title={__("Delete", "havenlytics")}
          >
            <i className="fas fa-trash"></i>
          </button>
        </div>
        
        {/* Field content */}
        <div className="">
          {renderFieldContent()}
        </div>
      </div>
    );
  }

  // Original rendering for other areas
  return (
    <div 
      className={` ${isMoving ? 'moving' : ''}`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{ position: 'relative' }}
    >
      {/* Action buttons - positioned above the field content */}
      <div className={`hvnly--builder---api_property__singleProperty__builder__field_actions ${isHovered ? 'show' : ''}`}>
        {canMoveUp && (
          <button
            type="button"
            className="hvnly_property_builder_field_action_btn move-up-btn"
            onClick={handleMoveUp}
            title={__("Move Up", "havenlytics")}
          >
            <i className="fas fa-arrow-up"></i>
          </button>
        )}
        
        {canMoveDown && (
          <button
            type="button"
            className="hvnly_property_builder_field_action_btn move-down-btn"
            onClick={handleMoveDown}
            title={__("Move Down", "havenlytics")}
          >
            <i className="fas fa-arrow-down"></i>
          </button>
        )}
        
        <button
          type="button"
          className="hvnly_property_builder_field_action_btn edit-btn"
          onClick={handleEdit}
          title={__("Edit", "havenlytics")}
        >
          <i className="fas fa-edit"></i>
        </button>
        
        <button
          type="button"
          className="hvnly_property_builder_field_action_btn delete-btn"
          onClick={handleDelete}
          title={__("Delete", "havenlytics")}
        >
          <i className="fas fa-trash"></i>
        </button>
      </div>
      
      {/* Field content */}
      <div className="">
        {renderFieldContent()}
      </div>
    </div>
  );
};

export default DynamicField;